namespace Areas.Building.Project {
    "use strict";

    export function goToProjectFromProjectGrid() {
        gotoSelected("ProjectDataGrid", "/Project/Profile/View/");
    }

    export function columnViewLink(cellElement: any, cellInfo: any) {
        let linkInfo = "<a href= '/Project/Profile/View/{placeholder}'>View</a>";

        buildCellContent(cellElement,
            () => { return cellInfo.data.projectId; },
            linkInfo);
    }
}